import moment from 'moment';

import { arrayHasLength, sortBy } from '~utils/array';

import { DEACTIVATABLE_TYPES, SORT_KEYS } from './constants';

const filterDisabledModifiers = (modifiers, disabledProducts) =>
  (modifiers || []).reduce((filteredModifiers, modifier) => {
    if (
      disabledProducts.some(
        ({ deactivatableId, deactivatableType }) =>
          deactivatableId === modifier.childModifierId && deactivatableType === DEACTIVATABLE_TYPES.MODIFIER
      )
    ) {
      return [...filteredModifiers];
    }

    if (arrayHasLength(modifier.children || [])) {
      const children = filterDisabledModifiers(modifier.children, disabledProducts);

      return [...filteredModifiers, { ...modifier, children }];
    }

    return [...filteredModifiers, { ...modifier, id: modifier.childModifierId }];
  }, []);

export const isAvailableProduct = (product) => {
  const { startDatetime, endDatetime, availability } = product;

  const startIsBeforeNow = startDatetime && moment(startDatetime).isSameOrBefore(moment());
  const endIsAfterNow = endDatetime && moment(endDatetime).isSameOrAfter(moment());
  const dateIsBetweenStartAndEnd = startIsBeforeNow && endIsAfterNow;

  const isAvailableToday =
    availability.length === 0 || availability.some((day) => day === moment().format('dddd').toLowerCase());

  const noStartAndEndDatetime = !startDatetime && !endDatetime;
  const onlyStartDatetime = startIsBeforeNow && !endDatetime;
  const onlyEndDatetime = endIsAfterNow && !startDatetime;

  return (
    (noStartAndEndDatetime || onlyStartDatetime || onlyEndDatetime || dateIsBetweenStartAndEnd) &&
    isAvailableToday
  );
};

// A throw here lands in GET_STATIC_MENU's successSelector, which dispatches no SUCCESS or FAILURE.
export const menuMapper = (data, disabledProducts = []) => {
  const orderedPriceGroups = sortBy(data?.priceGroups || [], SORT_KEYS.POSITION);
  const menu = orderedPriceGroups.reduce((categories, category) => {
    return [
      ...categories,
      {
        ...category,
        prices: (category?.prices || []).reduce((filteredPrices, price) => {
          if (!price?.product) {
            return filteredPrices;
          }

          const product = {
            ...price.product,
            endDatetime: price.product.endDatetime
              ? moment.utc(price.product.endDatetime).format('YYYY-MM-DDTHH:mm')
              : null,
            startDatetime: price.product.startDatetime
              ? moment.utc(price.product.startDatetime).format('YYYY-MM-DDTHH:mm')
              : null
          };

          const disabledProduct = disabledProducts.find(
            ({ deactivatableId, deactivatableType }) =>
              deactivatableId === product.id && deactivatableType === DEACTIVATABLE_TYPES.PRODUCT
          );

          const modifiers = filterDisabledModifiers(product.modifiers, disabledProducts);

          if (disabledProduct) {
            return [
              ...filteredPrices,
              {
                ...price,
                stock: false,
                withoutStockUntil: disabledProduct.endDate,
                product: {
                  ...product,
                  modifiers
                }
              }
            ];
          }

          return [
            ...filteredPrices,
            {
              ...price,
              stock: true,
              product: {
                ...product,
                modifiers
              }
            }
          ];
        }, [])
      }
    ];
  }, []);

  return menu;
};
